export default "__VITE_ASSET__49a56b42__"